// ─────────────────────────────────────────────────────────────────────────────
// Layout heights
// ─────────────────────────────────────────────────────────────────────────────
export const TIME_CARD_HEIGHT = 350; // header ~95px + clock 240px + padding ~15px

// ─────────────────────────────────────────────────────────────────────────────
// Analog clock geometry
// ─────────────────────────────────────────────────────────────────────────────
export const CLOCK_SIZE = 240;
export const CLOCK_CX = CLOCK_SIZE / 2;
export const CLOCK_CY = CLOCK_SIZE / 2;
export const CLOCK_BG_R = CLOCK_SIZE / 2 - 2;
export const NUM_R = CLOCK_SIZE / 2 - 26;
export const HAND_LEN = CLOCK_SIZE / 2 - 32;
export const SEL_DOT_R = 14;
export const CENTER_R = 4;

// ── Minute tick marks ─────────────────────────────────────────────────────────
/** Radius at which the 60 minute dots are placed (just inside the face edge) */
export const TICK_R = CLOCK_SIZE / 2 - 9;
/** Radius of a regular (non-5-minute) minute tick dot */
export const TICK_DOT_R = 1.8;
/** Radius of a major (every 5 minutes) minute tick dot */
export const TICK_MAJOR_R = 3;

// ─────────────────────────────────────────────────────────────────────────────
// Clock face labels
// ─────────────────────────────────────────────────────────────────────────────
export const HOUR_LABELS: number[] = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export const MINUTE_LABELS: string[] = [
  '00', '05', '10', '15', '20', '25',
  '30', '35', '40', '45', '50', '55',
];

// ─────────────────────────────────────────────────────────────────────────────
// Calendar header labels
// ─────────────────────────────────────────────────────────────────────────────
export const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

// ─────────────────────────────────────────────────────────────────────────────
// Picker step type
// ─────────────────────────────────────────────────────────────────────────────
export type PickerStep = 'date' | 'time';